import { Link } from "react-router-dom";
import { fmtDate, daysUntil } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function JobRow({ job, idx }) {
  const d = daysUntil(job.last_date);
  const ending = d != null && d >= 0 && d <= 7;
  const closed = d != null && d < 0;

  return (
    <Link to={`/jobs/${job.slug}`} data-testid={`job-row-${idx}`} className="job-row block bg-white border border-slate-200 hover:border-orange-300 hover:shadow-md rounded-lg p-4 md:p-5 transition-all">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-start gap-2 flex-wrap">
            <h3 className="font-semibold text-slate-900 text-base md:text-lg leading-snug">{job.title}</h3>
            {job.is_featured && <Badge className="bg-orange-600 text-white hover:bg-orange-700">Featured</Badge>}
            {ending && <Badge className="bg-red-600 text-white hover:bg-red-700">Ending in {d}d</Badge>}
            {closed && <Badge variant="outline" className="text-slate-500">Closed</Badge>}
          </div>
          <div className="mt-1 text-sm text-slate-600">{job.organization}</div>
          <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-500">
            <span><span className="font-semibold text-slate-700">Posts:</span> {job.total_posts || "—"}</span>
            <span><span className="font-semibold text-slate-700">Qualification:</span> {job.qualification}</span>
            <span><span className="font-semibold text-slate-700">State:</span> {job.state}</span>
            <span className={ending?"text-red-600 font-semibold":""}><span className="font-semibold text-slate-700">Last Date:</span> {fmtDate(job.last_date)}</span>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span className="text-xs uppercase tracking-wider font-bold text-slate-500 hidden md:block">{job.department.replace('-',' ')}</span>
          <span data-testid={`view-job-${idx}`} className="inline-flex items-center justify-center min-h-11 bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-semibold hover:bg-slate-800 transition-colors">View Details</span>
        </div>
      </div>
    </Link>
  );
}
